// @ts-nocheck
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import {
    chain,
    DispatchResetQuotes,
    PopulateApiParameter,
    SetCartStatus,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const SetPaymentDetails = createChainHandler("SetPaymentDetails", chain, props => {
    const paymentMethod = props?.apiParameter?.cart?.paymentMethod;
    const isCreditCard = paymentMethod?.isCreditCard;
    const isPaymentProfile = paymentMethod?.isPaymentProfile;

    if ((!isCreditCard && !isPaymentProfile) || props.parameter.isAdyenDropIn) {
        return;
    }

    const state = props.getState();
    const billToState = getBillToState(state, props.cartToUpdate.billToId);

    const formattedExpirationMonth =
        props.parameter.expirationMonth.toString().length === 1
            ? `0${props.parameter.expirationMonth}`
            : props.parameter.expirationMonth;
    const formattedExpirationYear = props.parameter.expirationYear.toString().substring(2);

    const paymentDetails = isPaymentProfile
        ? {
              cardNumber: paymentMethod?.name, // TokenEx Id
              cardExpirationDate: "", // Payment profile Information will be recovered in the backend
              cardType: paymentMethod?.cardType,
              nameOnCard: "",
          }
        : {
              cardNumber: `****${(props.parameter as any).tokenExReturnedLastFourDigits}`,
              cardExpirationDate: `${formattedExpirationMonth}${formattedExpirationYear}`,
              cardType: `${props.parameter.cardType}`,
              nameOnCard: `${props.parameter.cardHolderName}`,
          };

    const cartPayment = {
        customerNumber: billToState.value?.customerNumber,
        paymentDetails,
        creditCard: props.cartToUpdate.paymentOptions?.creditCard,
        storePaymentProfile: isPaymentProfile,
        paymentProfileId: isPaymentProfile ? paymentMethod?.name : null,
    };

    if (props.cartToUpdate) {
        props.cartToUpdate.properties.paymentDetailsInformation = JSON.stringify(cartPayment);
    }
});

export const SetShippingInstructions = createChainHandler("SetShippingInstructions", chain, props => {
    const state = props.getState();
    const useSplitShipping = state.store.pages.checkoutReviewAndSubmit.useSplitShipping;
    const shippingDeliveryInstruction = state.store.pages.checkoutReviewAndSubmit.shippingDeliveryInstruction;
    const shippingIsConstructionSite = state.store.pages.checkoutReviewAndSubmit.shippingIsConstructionSite;
    const shippingLeaveAtDoor = state.store.pages.checkoutReviewAndSubmit.shippingLeaveAtDoor;
    const shippingPhoneNumber = state.store.pages.checkoutReviewAndSubmit.shippingPhoneNumber;
    const shippingNotificationEmail = state.store.pages.checkoutReviewAndSubmit.shippingNotificationEmail;
    props.cartToUpdate.properties = {
        ...props.cartToUpdate.properties,
        useSplitShipping: useSplitShipping.toString(),
        shippingDeliveryInstruction,
        shippingIsConstructionSite: shippingIsConstructionSite.toString(),
        shippingLeaveAtDoor: shippingLeaveAtDoor.toString(),
        shippingPhoneNumber,
        shippingNotificationEmail,
    };
});

export const DispatchResetUseSplitShipping = createChainHandler("DispatchResetUseSplitShipping", chain, props => {
    props.dispatch({
        type: "Store/Pages/CheckoutReviewAndSubmit/Reset",
    });
});

export const SetCartNotes = createChainHandler("SetCartNotes", chain, props => {
    if (props.cartToUpdate && props.getState().pages.checkoutShipping.editedCartNotes !== undefined) {
        props.cartToUpdate.notes = props.getState().pages.checkoutShipping.editedCartNotes ?? "";
    }
});

addToChainAfter(chain, SetCartStatus, SetShippingInstructions);
addToChainAfter(chain, SetCartStatus, SetCartNotes);
addToChainAfter(chain, PopulateApiParameter, SetPaymentDetails);
addToChainAfter(chain, DispatchResetQuotes, DispatchResetUseSplitShipping);
